import { DataTable } from "@msuite/ui/table";
import type { OrderFormSchema } from "@msuite/utils/schemas";
import type { LoadCarrierListItem } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";
import { useOrderFormContext } from "../context";

/** Props Interface */
interface OrderFormLoadCarriersQuantityInputProps {
	item: LoadCarrierListItem;
}

export function OrderFormLoadCarriersQuantityInput({
	item,
}: OrderFormLoadCarriersQuantityInputProps) {
	/** Context */
	const { getLoadCarrierIndex } = useOrderFormContext();
	const itemIndex = getLoadCarrierIndex(item.id);

	/** Hooks */
	const methods = useFormContext<OrderFormSchema>();

	/** Guard */
	// The row exists before the form array has been synced to the carrier list, and a negative
	// index would register `loadCarriers.-1.quantity`.
	if (itemIndex < 0) return null;

	/** Render */
	return (
		<DataTable.Input
			type="number"
			min={0}
			control={methods.control}
			name={`loadCarriers.${itemIndex}.quantity`}
			placeholder="0"
		/>
	);
}
